app.directive('uiPhoneCode', [function () {
    return {
        restrict: "A",
        scope: {
            phone_code: "=uiPhoneCode",
            init: "=",
            update: "&"
        },
        template: '' +
            '<div class="select__value">' +
            '   <span class="phone__flag flag flag--{{selected.id}}"></span>' +
            '   <span class="phone__code">{{selected.code}}</span>' +
            '</div>' +
            '<div class="select__box">' +
            '   <div class="phone__search form__control mb-10">' +
            '       <div class="form__input form__input--sm">' +
            '           <input placeholder="Search" data-ng-model="filterStr"/>' +
            '       </div>' +
            '   </div>' +
            '   <ul class="phone__codes">' +
            '       <li ng-repeat="item in items | filter: countryFilter" ng-click="select(item)" ng-class="{divide:item.divide}">' +
            '           <span class="phone__flag flag flag--{{item.id}}"></span>{{item.name}}<span class="phone__code">{{item.code}}</span>' +
            '       </li>' +
            '   </ul>' +
            '</div>',
        link: function ($scope, element, attrs) {
            angular.element(element[0]).on('click', function (e) {
                angular.element(document.querySelectorAll('.select.active')).removeClass("active");
                angular.element(this).addClass("active");
                e.stopPropagation();
            });

            angular.element(element[0].querySelector('.select__value')).on('click', function (e) {
                if (angular.element(this).parent().hasClass('active')) {
                    angular.element(document.querySelectorAll('.select.active')).removeClass("active");
                    e.stopPropagation();
                }
            });

            $scope.selected = $scope.init || {id: 'th', code: '+66'};
            $scope.phone_code = $scope.selected.code;

            $scope.filterStr = '';
            $scope.items = COUNTRIES;

            $scope.countryFilter = function (item) {
                if (item.top && $scope.filterStr) return false
                return item.name.toLowerCase().indexOf($scope.filterStr.toLowerCase()) > -1 || item.code.indexOf($scope.filterStr) > -1;
            };
            $scope.select = function (item) {
                $scope.selected = item;
                $scope.phone_code = item.code;

                $scope.$$postDigest(function () {
                    $scope.$applyAsync(function () {
                        $scope.update();
                        angular.element(element[0]).removeClass("active");
                    });
                });
            };
        }
    };
}]);

COUNTRIES = [
    {'id': 'th', 'name': 'Thailand (ไทย)', 'code': '+66', 'top': true},
    {'id': 'gb', 'name': 'United Kingdom', 'code': '+44', 'top': true},
    {'id': 'ru', 'name': 'Russia (Россия)', 'code': '+7', 'top': true, 'divide': true},
    {'id': 'af', 'name': 'Afghanistan (\u202bافغانستان\u202c\u200e)', 'code': '+93'},
    {'id': 'al', 'name': 'Albania (Shqipëri)', 'code': '+355'},
    {'id': 'dz', 'name': 'Algeria (\u202bالجزائر\u202c\u200e)', 'code': '+213'},
    {'id': 'as', 'name': 'American Samoa', 'code': '+1'},
    {'id': 'ad', 'name': 'Andorra', 'code': '+376'},
    {'id': 'ao', 'name': 'Angola', 'code': '+244'},
    {'id': 'ai', 'name': 'Anguilla', 'code': '+1'},
    {'id': 'ag', 'name': 'Antigua and Barbuda', 'code': '+1'},
    {'id': 'ar', 'name': 'Argentina', 'code': '+54'},
    {'id': 'am', 'name': 'Armenia (Հայաստան)', 'code': '+374'},
    {'id': 'aw', 'name': 'Aruba', 'code': '+297'},
    {'id': 'au', 'name': 'Australia', 'code': '+61'},
    {'id': 'at', 'name': 'Austria (Österreich)', 'code': '+43'},
    {'id': 'az', 'name': 'Azerbaijan (Azərbaycan)', 'code': '+994'},
    {'id': 'bs', 'name': 'Bahamas', 'code': '+1'},
    {'id': 'bh', 'name': 'Bahrain (\u202bالبحرين\u202c\u200e)', 'code': '+973'},
    {'id': 'bd', 'name': 'Bangladesh (বাংলাদেশ)', 'code': '+880'},
    {'id': 'bb', 'name': 'Barbados', 'code': '+1'},
    {'id': 'by', 'name': 'Belarus (Беларусь)', 'code': '+375'},
    {'id': 'be', 'name': 'Belgium (België)', 'code': '+32'},
    {'id': 'bz', 'name': 'Belize', 'code': '+501'},
    {'id': 'bj', 'name': 'Benin (Bénin)', 'code': '+229'},
    {'id': 'bm', 'name': 'Bermuda', 'code': '+1'},
    {'id': 'bt', 'name': 'Bhutan (འབྲུག)', 'code': '+975'},
    {'id': 'bo', 'name': 'Bolivia', 'code': '+591'},
    {'id': 'ba', 'name': 'Bosnia and Herzegovina (Босна и Херцеговина)', 'code': '+387'},
    {'id': 'bw', 'name': 'Botswana', 'code': '+267'},
    {'id': 'br', 'name': 'Brazil (Brasil)', 'code': '+55'},
    {'id': 'io', 'name': 'British Indian Ocean Territory', 'code': '+246'},
    {'id': 'vg', 'name': 'British Virgin Islands', 'code': '+1'},
    {'id': 'bn', 'name': 'Brunei', 'code': '+673'},
    {'id': 'bg', 'name': 'Bulgaria (България)', 'code': '+359'},
    {'id': 'bf', 'name': 'Burkina Faso', 'code': '+226'},
    {'id': 'bi', 'name': 'Burundi (Uburundi)', 'code': '+257'},
    {'id': 'kh', 'name': 'Cambodia (កម្ពុជា)', 'code': '+855'},
    {'id': 'cm', 'name': 'Cameroon (Cameroun)', 'code': '+237'},
    {'id': 'ca', 'name': 'Canada', 'code': '+1'},
    {'id': 'cv', 'name': 'Cape Verde (Kabu Verdi)', 'code': '+238'},
    {'id': 'bq', 'name': 'Caribbean Netherlands', 'code': '+599'},
    {'id': 'ky', 'name': 'Cayman Islands', 'code': '+1'},
    {'id': 'cf', 'name': 'Central African Republic (République centrafricaine)', 'code': '+236'},
    {'id': 'td', 'name': 'Chad (Tchad)', 'code': '+235'},
    {'id': 'cl', 'name': 'Chile', 'code': '+56'},
    {'id': 'cn', 'name': 'China (中国)', 'code': '+86'},
    {'id': 'cx', 'name': 'Christmas Island', 'code': '+61'},
    {'id': 'cc', 'name': 'Cocos (Keeling) Islands', 'code': '+61'},
    {'id': 'co', 'name': 'Colombia', 'code': '+57'},
    {'id': 'km', 'name': 'Comoros (\u202bجزر القمر\u202c\u200e)', 'code': '+269'},
    {'id': 'cd', 'name': 'Congo (DRC) (Jamhuri ya Kidemokrasia ya Kongo)', 'code': '+243'},
    {'id': 'cg', 'name': 'Congo (Republic) (Congo-Brazzaville)', 'code': '+242'},
    {'id': 'ck', 'name': 'Cook Islands', 'code': '+682'},
    {'id': 'cr', 'name': 'Costa Rica', 'code': '+506'},
    {'id': 'ci', 'name': 'Côte d’Ivoire', 'code': '+225'},
    {'id': 'hr', 'name': 'Croatia (Hrvatska)', 'code': '+385'},
    {'id': 'cu', 'name': 'Cuba', 'code': '+53'},
    {'id': 'cw', 'name': 'Curaçao', 'code': '+599'},
    {'id': 'cy', 'name': 'Cyprus (Κύπρος)', 'code': '+357'},
    {'id': 'cz', 'name': 'Czech Republic (Česká republika)', 'code': '+420'},
    {'id': 'dk', 'name': 'Denmark (Danmark)', 'code': '+45'},
    {'id': 'dj', 'name': 'Djibouti', 'code': '+253'},
    {'id': 'dm', 'name': 'Dominica', 'code': '+1'},
    {'id': 'do', 'name': 'Dominican Republic (República Dominicana)', 'code': '+1'},
    {'id': 'ec', 'name': 'Ecuador', 'code': '+593'},
    {'id': 'eg', 'name': 'Egypt (\u202bمصر\u202c\u200e)', 'code': '+20'},
    {'id': 'sv', 'name': 'El Salvador', 'code': '+503'},
    {'id': 'gq', 'name': 'Equatorial Guinea (Guinea Ecuatorial)', 'code': '+240'},
    {'id': 'er', 'name': 'Eritrea', 'code': '+291'},
    {'id': 'ee', 'name': 'Estonia (Eesti)', 'code': '+372'},
    {'id': 'et', 'name': 'Ethiopia', 'code': '+251'},
    {'id': 'fk', 'name': 'Falkland Islands (Islas Malvinas)', 'code': '+500'},
    {'id': 'fo', 'name': 'Faroe Islands (Føroyar)', 'code': '+298'},
    {'id': 'fj', 'name': 'Fiji', 'code': '+679'},
    {'id': 'fi', 'name': 'Finland (Suomi)', 'code': '+358'},
    {'id': 'fr', 'name': 'France', 'code': '+33'},
    {'id': 'gf', 'name': 'French Guiana (Guyane française)', 'code': '+594'},
    {'id': 'pf', 'name': 'French Polynesia (Polynésie française)', 'code': '+689'},
    {'id': 'ga', 'name': 'Gabon', 'code': '+241'},
    {'id': 'gm', 'name': 'Gambia', 'code': '+220'},
    {'id': 'ge', 'name': 'Georgia (საქართველო)', 'code': '+995'},
    {'id': 'de', 'name': 'Germany (Deutschland)', 'code': '+49'},
    {'id': 'gh', 'name': 'Ghana (Gaana)', 'code': '+233'},
    {'id': 'gi', 'name': 'Gibraltar', 'code': '+350'},
    {'id': 'gr', 'name': 'Greece (Ελλάδα)', 'code': '+30'},
    {'id': 'gl', 'name': 'Greenland (Kalaallit Nunaat)', 'code': '+299'},
    {'id': 'gd', 'name': 'Grenada', 'code': '+1'},
    {'id': 'gp', 'name': 'Guadeloupe', 'code': '+590'},
    {'id': 'gu', 'name': 'Guam', 'code': '+1'},
    {'id': 'gt', 'name': 'Guatemala', 'code': '+502'},
    {'id': 'gg', 'name': 'Guernsey', 'code': '+44'},
    {'id': 'gn', 'name': 'Guinea (Guinée)', 'code': '+224'},
    {'id': 'gw', 'name': 'Guinea-Bissau (Guiné Bissau)', 'code': '+245'},
    {'id': 'gy', 'name': 'Guyana', 'code': '+592'},
    {'id': 'ht', 'name': 'Haiti', 'code': '+509'},
    {'id': 'hn', 'name': 'Honduras', 'code': '+504'},
    {'id': 'hk', 'name': 'Hong Kong (香港)', 'code': '+852'},
    {'id': 'hu', 'name': 'Hungary (Magyarország)', 'code': '+36'},
    {'id': 'is', 'name': 'Iceland (Ísland)', 'code': '+354'},
    {'id': 'in', 'name': 'India (भारत)', 'code': '+91'},
    {'id': 'id', 'name': 'Indonesia', 'code': '+62'},
    {'id': 'ir', 'name': 'Iran (\u202bایران\u202c\u200e)', 'code': '+98'},
    {'id': 'iq', 'name': 'Iraq (\u202bالعراق\u202c\u200e)', 'code': '+964'},
    {'id': 'ie', 'name': 'Ireland', 'code': '+353'},
    {'id': 'im', 'name': 'Isle of Man', 'code': '+44'},
    {'id': 'il', 'name': 'Israel (\u202bישראל\u202c\u200e)', 'code': '+972'},
    {'id': 'it', 'name': 'Italy (Italia)', 'code': '+39'},
    {'id': 'jm', 'name': 'Jamaica', 'code': '+1'},
    {'id': 'jp', 'name': 'Japan (日本)', 'code': '+81'},
    {'id': 'je', 'name': 'Jersey', 'code': '+44'},
    {'id': 'jo', 'name': 'Jordan (\u202bالأردن\u202c\u200e)', 'code': '+962'},
    {'id': 'kz', 'name': 'Kazakhstan (Казахстан)', 'code': '+7'},
    {'id': 'ke', 'name': 'Kenya', 'code': '+254'},
    {'id': 'ki', 'name': 'Kiribati', 'code': '+686'},
    {'id': 'xk', 'name': 'Kosovo', 'code': '+383'},
    {'id': 'kw', 'name': 'Kuwait (\u202bالكويت\u202c\u200e)', 'code': '+965'},
    {'id': 'kg', 'name': 'Kyrgyzstan (Кыргызстан)', 'code': '+996'},
    {'id': 'la', 'name': 'Laos (ລາວ)', 'code': '+856'},
    {'id': 'lv', 'name': 'Latvia (Latvija)', 'code': '+371'},
    {'id': 'lb', 'name': 'Lebanon (\u202bلبنان\u202c\u200e)', 'code': '+961'},
    {'id': 'ls', 'name': 'Lesotho', 'code': '+266'},
    {'id': 'lr', 'name': 'Liberia', 'code': '+231'},
    {'id': 'ly', 'name': 'Libya (\u202bليبيا\u202c\u200e)', 'code': '+218'},
    {'id': 'li', 'name': 'Liechtenstein', 'code': '+423'},
    {'id': 'lt', 'name': 'Lithuania (Lietuva)', 'code': '+370'},
    {'id': 'lu', 'name': 'Luxembourg', 'code': '+352'},
    {'id': 'mo', 'name': 'Macau (澳門)', 'code': '+853'},
    {'id': 'mk', 'name': 'Macedonia (FYROM) (Македонија)', 'code': '+389'},
    {'id': 'mg', 'name': 'Madagascar (Madagasikara)', 'code': '+261'},
    {'id': 'mw', 'name': 'Malawi', 'code': '+265'},
    {'id': 'my', 'name': 'Malaysia', 'code': '+60'},
    {'id': 'mv', 'name': 'Maldives', 'code': '+960'},
    {'id': 'ml', 'name': 'Mali', 'code': '+223'},
    {'id': 'mt', 'name': 'Malta', 'code': '+356'},
    {'id': 'mh', 'name': 'Marshall Islands', 'code': '+692'},
    {'id': 'mq', 'name': 'Martinique', 'code': '+596'},
    {'id': 'mr', 'name': 'Mauritania (\u202bموريتانيا\u202c\u200e)', 'code': '+222'},
    {'id': 'mu', 'name': 'Mauritius (Moris)', 'code': '+230'},
    {'id': 'yt', 'name': 'Mayotte', 'code': '+262'},
    {'id': 'mx', 'name': 'Mexico (México)', 'code': '+52'},
    {'id': 'fm', 'name': 'Micronesia', 'code': '+691'},
    {'id': 'md', 'name': 'Moldova (Republica Moldova)', 'code': '+373'},
    {'id': 'mc', 'name': 'Monaco', 'code': '+377'},
    {'id': 'mn', 'name': 'Mongolia (Монгол)', 'code': '+976'},
    {'id': 'me', 'name': 'Montenegro (Crna Gora)', 'code': '+382'},
    {'id': 'ms', 'name': 'Montserrat', 'code': '+1'},
    {'id': 'ma', 'name': 'Morocco (\u202bالمغرب\u202c\u200e)', 'code': '+212'},
    {'id': 'mz', 'name': 'Mozambique (Moçambique)', 'code': '+258'},
    {'id': 'mm', 'name': 'Myanmar (Burma) (မြန်မာ)', 'code': '+95'},
    {'id': 'na', 'name': 'Namibia (Namibië)', 'code': '+264'},
    {'id': 'nr', 'name': 'Nauru', 'code': '+674'},
    {'id': 'np', 'name': 'Nepal (नेपाल)', 'code': '+977'},
    {'id': 'nl', 'name': 'Netherlands (Nederland)', 'code': '+31'},
    {'id': 'nc', 'name': 'New Caledonia (Nouvelle-Calédonie)', 'code': '+687'},
    {'id': 'nz', 'name': 'New Zealand', 'code': '+64'},
    {'id': 'ni', 'name': 'Nicaragua', 'code': '+505'},
    {'id': 'ne', 'name': 'Niger (Nijar)', 'code': '+227'},
    {'id': 'ng', 'name': 'Nigeria', 'code': '+234'},
    {'id': 'nu', 'name': 'Niue', 'code': '+683'},
    {'id': 'nf', 'name': 'Norfolk Island', 'code': '+672'},
    {'id': 'kp', 'name': 'North Korea (조선 민주주의 인민 공화국)', 'code': '+850'},
    {'id': 'mp', 'name': 'Northern Mariana Islands', 'code': '+1'},
    {'id': 'no', 'name': 'Norway (Norge)', 'code': '+47'},
    {'id': 'om', 'name': 'Oman (\u202bعُمان\u202c\u200e)', 'code': '+968'},
    {'id': 'pk', 'name': 'Pakistan (\u202bپاکستان\u202c\u200e)', 'code': '+92'},
    {'id': 'pw', 'name': 'Palau', 'code': '+680'},
    {'id': 'ps', 'name': 'Palestine (\u202bفلسطين\u202c\u200e)', 'code': '+970'},
    {'id': 'pa', 'name': 'Panama (Panamá)', 'code': '+507'},
    {'id': 'pg', 'name': 'Papua New Guinea', 'code': '+675'},
    {'id': 'py', 'name': 'Paraguay', 'code': '+595'},
    {'id': 'pe', 'name': 'Peru (Perú)', 'code': '+51'},
    {'id': 'ph', 'name': 'Philippines', 'code': '+63'},
    {'id': 'pl', 'name': 'Poland (Polska)', 'code': '+48'},
    {'id': 'pt', 'name': 'Portugal', 'code': '+351'},
    {'id': 'pr', 'name': 'Puerto Rico', 'code': '+1'},
    {'id': 'qa', 'name': 'Qatar (\u202bقطر\u202c\u200e)', 'code': '+974'},
    {'id': 're', 'name': 'Réunion (La Réunion)', 'code': '+262'},
    {'id': 'ro', 'name': 'Romania (România)', 'code': '+40'},
    {'id': 'ru', 'name': 'Russia (Россия)', 'code': '+7'},
    {'id': 'rw', 'name': 'Rwanda', 'code': '+250'},
    {'id': 'bl', 'name': 'Saint Barthélemy', 'code': '+590'},
    {'id': 'sh', 'name': 'Saint Helena', 'code': '+290'},
    {'id': 'kn', 'name': 'Saint Kitts and Nevis', 'code': '+1'},
    {'id': 'lc', 'name': 'Saint Lucia', 'code': '+1'},
    {'id': 'mf', 'name': 'Saint Martin (Saint-Martin (partie française))', 'code': '+590'},
    {'id': 'pm', 'name': 'Saint Pierre and Miquelon (Saint-Pierre-et-Miquelon)', 'code': '+508'},
    {'id': 'vc', 'name': 'Saint Vincent and the Grenadines', 'code': '+1'},
    {'id': 'ws', 'name': 'Samoa', 'code': '+685'},
    {'id': 'sm', 'name': 'San Marino', 'code': '+378'},
    {'id': 'st', 'name': 'São Tomé and Príncipe (São Tomé e Príncipe)', 'code': '+239'},
    {'id': 'sa', 'name': 'Saudi Arabia (\u202bالمملكة العربية السعودية\u202c\u200e)', 'code': '+966'},
    {'id': 'sn', 'name': 'Senegal (Sénégal)', 'code': '+221'},
    {'id': 'rs', 'name': 'Serbia (Србија)', 'code': '+381'},
    {'id': 'sc', 'name': 'Seychelles', 'code': '+248'},
    {'id': 'sl', 'name': 'Sierra Leone', 'code': '+232'},
    {'id': 'sg', 'name': 'Singapore', 'code': '+65'},
    {'id': 'sx', 'name': 'Sint Maarten', 'code': '+1'},
    {'id': 'sk', 'name': 'Slovakia (Slovensko)', 'code': '+421'},
    {'id': 'si', 'name': 'Slovenia (Slovenija)', 'code': '+386'},
    {'id': 'sb', 'name': 'Solomon Islands', 'code': '+677'},
    {'id': 'so', 'name': 'Somalia (Soomaaliya)', 'code': '+252'},
    {'id': 'za', 'name': 'South Africa', 'code': '+27'},
    {'id': 'kr', 'name': 'South Korea (대한민국)', 'code': '+82'},
    {'id': 'ss', 'name': 'South Sudan (\u202bجنوب السودان\u202c\u200e)', 'code': '+211'},
    {'id': 'es', 'name': 'Spain (España)', 'code': '+34'},
    {'id': 'lk', 'name': 'Sri Lanka (ශ්\u200dරී ලංකාව)', 'code': '+94'},
    {'id': 'sd', 'name': 'Sudan (\u202bالسودان\u202c\u200e)', 'code': '+249'},
    {'id': 'sr', 'name': 'Suricountry', 'code': '+597'},
    {'id': 'sj', 'name': 'Svalbard and Jan Mayen', 'code': '+47'},
    {'id': 'sz', 'name': 'Swaziland', 'code': '+268'},
    {'id': 'se', 'name': 'Sweden (Sverige)', 'code': '+46'},
    {'id': 'ch', 'name': 'Switzerland (Schweiz)', 'code': '+41'},
    {'id': 'sy', 'name': 'Syria (\u202bسوريا\u202c\u200e)', 'code': '+963'},
    {'id': 'tw', 'name': 'Taiwan (台灣)', 'code': '+886'},
    {'id': 'tj', 'name': 'Tajikistan', 'code': '+992'},
    {'id': 'tz', 'name': 'Tanzania', 'code': '+255'},
    {'id': 'th', 'name': 'Thailand (ไทย)', 'code': '+66'},
    {'id': 'tl', 'name': 'Timor-Leste', 'code': '+670'},
    {'id': 'tg', 'name': 'Togo', 'code': '+228'},
    {'id': 'tk', 'name': 'Tokelau', 'code': '+690'},
    {'id': 'to', 'name': 'Tonga', 'code': '+676'},
    {'id': 'tt', 'name': 'Trinidad and Tobago', 'code': '+1'},
    {'id': 'tn', 'name': 'Tunisia (\u202bتونس\u202c\u200e)', 'code': '+216'},
    {'id': 'tr', 'name': 'Turkey (Türkiye)', 'code': '+90'},
    {'id': 'tm', 'name': 'Turkmenistan', 'code': '+993'},
    {'id': 'tc', 'name': 'Turks and Caicos Islands', 'code': '+1'},
    {'id': 'tv', 'name': 'Tuvalu', 'code': '+688'},
    {'id': 'vi', 'name': 'U.S. Virgin Islands', 'code': '+1'},
    {'id': 'ug', 'name': 'Uganda', 'code': '+256'},
    {'id': 'ua', 'name': 'Ukraine (Україна)', 'code': '+380'},
    {'id': 'ae', 'name': 'United Arab Emirates (\u202bالإمارات العربية المتحدة\u202c\u200e)', 'code': '+971'},
    {'id': 'gb', 'name': 'United Kingdom', 'code': '+44'},
    {'id': 'us', 'name': 'United States', 'code': '+1'},
    {'id': 'uy', 'name': 'Uruguay', 'code': '+598'},
    {'id': 'uz', 'name': 'Uzbekistan (Oʻzbekiston)', 'code': '+998'},
    {'id': 'vu', 'name': 'Vanuatu', 'code': '+678'},
    {'id': 'va', 'name': 'Vatican City (Città del Vaticano)', 'code': '+39'},
    {'id': 've', 'name': 'Venezuela', 'code': '+58'},
    {'id': 'vn', 'name': 'Vietnam (Việt Nam)', 'code': '+84'},
    {'id': 'wf', 'name': 'Wallis and Futuna (Wallis-et-Futuna)', 'code': '+681'},
    {'id': 'eh', 'name': 'Western Sahara (\u202bالصحراء الغربية\u202c\u200e)', 'code': '+212'},
    {'id': 'ye', 'name': 'Yemen (\u202bاليمن\u202c\u200e)', 'code': '+967'},
    {'id': 'zm', 'name': 'Zambia', 'code': '+260'},
    {'id': 'zw', 'name': 'Zimbabwe', 'code': '+263'},
    {'id': 'ax', 'name': 'Åland Islands', 'code': '+358'},
];